import { skipToken, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { com } from '@eidu/web'
import getRegistryAsset from './api/registry/getRegistryAsset'
import publishEntity, { PublishEntityResponse } from './api/entity/data/publishEntity'
import { entityKeys, registryAssetKeys } from './queryKeys'
import { versionsQueryKey } from '../pages/entity/kinds/asset/publish/useVersions'
import EntityId = com.eidu.entity.EntityId

const useRegistryAsset = (entityId: string | undefined) => {
  const query = useQuery({
    queryKey: registryAssetKeys.detail(entityId ?? ''),
    queryFn: entityId ? () => getRegistryAsset(entityId) : skipToken,
  })
  return {
    detail: query.data,
    isLoading: query.isLoading,
    error: query.error,
  }
}

export const usePublishEntity = () => {
  const queryClient = useQueryClient()
  const { mutateAsync, isPending, error } = useMutation({
    mutationFn: ({
      id,
      compatibility,
    }: {
      id: EntityId
      compatibility?: Record<string, string>
    }): Promise<PublishEntityResponse> => publishEntity({ id, compatibility }),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: versionsQueryKey(id) })
      queryClient.invalidateQueries({ queryKey: registryAssetKeys.detail(id.toString()) })
      // Publishing writes asset.version-log on the entity; refetch so the local cache picks up the new link.
      queryClient.invalidateQueries({ queryKey: entityKeys.detail(id) })
      queryClient.invalidateQueries({ queryKey: [...entityKeys.all, 'byIds'] })
    },
  })
  return { publish: mutateAsync, isPending, error }
}

export default useRegistryAsset
